import { Suspense, useCallback, useEffect, useState } from "react";
import axiosInstance from "../../axiosInterceptor";
import { deleteItem, fetchPaginationData } from "../../utils/apiUtils";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import {
  checkImage,
  CopyButton,
  DeleteSingleButton,
} from "../../Components/TableHelper";
import { formatDate } from "../../utils/constant";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
const Base_url = process.env.REACT_APP_API_BASE_URL;
const UploadsFile = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const perPage = 10;
  const [uploadLoading, setUploadLoading] = useState(false);
  const [desktopFile, setDesktopFile] = useState(null);
  const fetchDataPagination = useCallback(
    async (page = 1, currentPerPage = perPage) => {
      const requestData = {
        perPage: currentPerPage,
        pageNo: page,
      };
      await fetchPaginationData(
        "upload/pagination",
        requestData,
        setdata,
        setTotalCount,
        setCurrentPage,
        setLoading,
      );
    },
    [perPage],
  );

  useEffect(() => {
    fetchDataPagination(1);
  }, [fetchDataPagination]);

  const totalPages = Math.ceil(totalCount / perPage);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };
  const handleDelete = async (data) => {
    setDeleteItemId(data);

    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);

    try {
      const res = await deleteItem(
        "upload/delete",
        deleteItemId?._id,
        fetchDataPagination,
      );

      setDeleteItemId({});

      setDeleteModalOpen(false);

      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleUpload = async () => {
    if (!desktopFile) {
      toast.error("Please select image");
      return;
    }

    setUploadLoading(true);

    try {
      const formData = new FormData();

      formData.append("file", desktopFile);

      const response = await axiosInstance.post("/upload/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        toast.success(response.data.message);
        setDesktopFile(null);
        fetchDataPagination(currentPage);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);

      return error;
    } finally {
      setUploadLoading(false);
    }
  };
  const handleCopy = async (url) => {
    try {
      await navigator.clipboard.writeText(Base_url + url);
      toast.success("Copied Successfully");
    } catch (error) {
      toast.error("Copy Failed");
    }
  };
  const Tableheader = ["Image", "Created At", "Action"];
  const breadcrumbdata = [
    {
      label: "Home",
      path: "/dashboard",
    },

    {
      label: "Upload File",
      path: "*",
    },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">Upload File</h3>

          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="card m-0 mb-3">
          <div className="card-body">
            <div className="row align-items-end">
              <div className="col-sm-4">
                <label className="form-label">Upload File</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setDesktopFile(e.target.files[0])}
                />
              </div>

              <div className="col-sm-2">
                <Button
                  color="primary"
                  onClick={handleUpload}
                  disabled={!desktopFile || uploadLoading}
                >
                  {uploadLoading ? "Uploading..." : "Upload"}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="custom-table table table-striped"
                    id="uploadtable"
                  >
                    <thead>
                      <tr>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold" key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : data?.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item._id || index}>
                            <td>{checkImage(item.fileUrl)}</td>
                            <td>{formatDate(item.updatedAt)}</td>
                            <td >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "center",
                                }}
                              >
                                <DeleteSingleButton
                                  item={item}
                                  handleDelete={handleDelete}
                                />
                                <CopyButton
                                  onClick={() => handleCopy(item.fileUrl)}
                                  name="file URL"
                                /></div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="upload file"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default UploadsFile;
